import { render, staticRenderFns } from "./otherDeclaration.vue?vue&type=template&id=06f2b60c&scoped=true&"
import script from "./otherDeclaration.vue?vue&type=script&lang=js&"
export * from "./otherDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./otherDeclaration.vue?vue&type=style&index=0&id=06f2b60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f2b60c",
  null
  
)

export default component.exports